<script setup>
import { Swiper, SwiperSlide } from 'swiper/vue';
import { Autoplay, EffectCreative, Navigation } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import SectionTop from "@/components/additional/SectionTop.vue";
import ChooseCard from "@/components/additional/ChooseCard.vue";

const cards = [
  {
    title: "Global Mindset, Agile Execution",
    text: "We scale with speed, adapt to diverse markets, and stay aligned with evolving user expectations.",
    img: "card1.jpg"
  },
  {
    title: "Mobile-First Philosophy",
    text: "Our tech is designed to perform flawlessly across mobile platforms — prioritizing stability, UX, and compliance.",
    img: "card2.jpg"
  },
  {
    title: "Player-Focused by Design",
    text: "From regional payment solutions to multilingual interfaces, we personalize player experiences without compromising performance.",
    img: "card3.jpg"
  },
  {
    title: "Strategic Industry Alliances",
    text: "Galazia partners with top-tier content studios and data suppliers to offer a rich, interconnected betting and gaming environment.",
    img: "card4.jpg"
  },
  {
    title: "High-Performance Team",
    text: "Small, skilled, and focused — our team executes efficiently, without unnecessary layers of corporate overhead.",
    img: "card5.jpg"
  },
]
</script>

<template>
  <section class="why-choose relative" id="why-choose-galazia">
    <img src="../../assets/bg.webp" alt="section background" class="absolute" />
    <div class="why-choose__content flex flex-col align-center relative">
      <SectionTop secondary>Why Choose Galazia</SectionTop>
      <p class="text-l" v-motion :initial="{ y: 10, opacity: 0 }" :visibleOnce="{ y: 0, scale: 1, opacity: 1 }" :duration="700">Galazia isn’t just another gaming provider — we are a user-centric, technology-first company with a long-term vision.</p>
    </div>
    <div class="why-choose__cards relative">
      <ChooseCard
          v-for="(card, index) in cards"
          :key="index"
          :title="card.title"
          :text="card.text"
          :img="card.img"
      />
    </div>
    <div class="why-choose__mobile">
      <swiper
          :modules="[Autoplay, EffectCreative, Navigation]"
          :navigation="{
          nextEl: '.swiper-button-next-cust',
          prevEl: '.swiper-button-prev-cust'
        }"
          :pagination="{ clickable: true }"
          :spaceBetween="30"
          class="slider"
          :loop="true"
          :speed="700"

      >
        <swiper-slide v-for="(card, index) in cards" :key="index">
          <ChooseCard
              :title="card.title"
              :text="card.text"
              :img="card.img"
          />
        </swiper-slide>
      </swiper>
      <div class="slider-controls flex">
        <div class="swiper-button-prev-cust swiper-btn-prev flex align-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none">
            <path d="M2.32324 1.86269L6.93176 6.50019L2.32324 11.1377" stroke="#0E0E0E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
        <div class="swiper-button-next-cust swiper-btn-next flex align-center justify-center">
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="13" viewBox="0 0 9 13" fill="none">
            <path d="M2.32324 1.86269L6.93176 6.50019L2.32324 11.1377" stroke="#0E0E0E" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
    </div>
  </section>
</template>

<style lang="scss">
.why-choose {
  padding: 8.333vw 8.333vw 5.556vw;
  & > img {
    transform: rotate(-25deg);
    width: 300%;
    z-index: 0;
    left: -130%;
    top: -10%;
  }
  &__content {
    text-align: center;
    width: 60%;
    margin: 0 auto 4.375vw;
    gap: 2.917vw;
    z-index: 1;
  }
  &__cards {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: 2.569vw;
    row-gap: 1.736vw;
    z-index: 1;
    & > div:nth-child(3) {
      grid-column: span 2;
    }
  }
  &__mobile {
    display: none;
  }
}

@media (max-width: 850px) {
  .why-choose__cards {
    grid-template-columns: 1fr;
    & > div:nth-child(3) {
      grid-column: 1;
    }
  }
}
@media (max-width: 768px) {
  .why-choose {
    padding: 50px 24px;
    &__content {
      width: 100%;
      gap: 48px;
      margin: 0 0 41px;
      p {
        line-height: 37px;
      }
    }
    &__cards {
      display: none;
    }
    & > img {
      width: 1800px;
      height: 1500px;
      left: -130%;
      top: -25%;
      transform: rotate(25deg);
    }
    &__mobile {
      display: block;
      position: relative;
      z-index: 2;
      .swiper {
        overflow: visible;
      }
      .slider-controls {
        gap: 8px;
        margin: 23px 0 0 auto;
        width: fit-content;
      }
    }
  }
}
</style>